<template>
  <div class="container" v-html="content"></div>
</template>
<script>
export default {
  data() {
    return {
      content: "",
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.$get("/api-login-get_user_registration_agreement_data", {}).then(
        (res) => {
          if (res.data) {
            this.content = this.escape2Html(res.data);
          }
        }
      );
    },
    escape2Html(str) {
      if (str) {
        var arrEntities = {
          lt: "<",
          gt: ">",
          nbsp: " ",
          amp: "&",
          quot: '"',
        };
        return str.replace(/&(lt|gt|nbsp|amp|quot);/gi, function(all, t) {
          return arrEntities[t];
        });
      }
    },
  },
};
</script>
<style  scoped>
.container {
  width: 100%;
  font-size: 14px;
  padding: 15px;
  box-sizing: border-box;
}
</style>
